import {
  EngagementLookbookItem,
  EngagementLookbookWithUser,
  LookbookResponseDto,
  ProductListResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';

export function mapLookbooksListsAvailability(
  lookBooks: EngagementLookbookWithUser[],
  lists: ProductListResponseDto[],
) {
  const listMap = listToMap(lists);

  return lookBooks.map((lookBook) => {
    lookBook.items = lookBook.items.map((list) => ({
      ...list,
      productList: listMap.get(list.productListId),
    })) as EngagementLookbookItem[];
    return lookBook;
  });
}

export function mapSingleLookBookListsAvailability(
  lookBook: LookbookResponseDto,
  lists: ProductListResponseDto[],
) {
  const listMap = listToMap(lists);

  lookBook.items = lookBook.items.map((list) => ({
    ...list,
    productList: listMap.get(list.productListId),
  })) as EngagementLookbookItem[];

  return lookBook;
}

function listToMap(lists: ProductListResponseDto[]) {
  const listMapper = lists.map<[string, ProductListResponseDto]>((list) => [
    list.id,
    list,
  ]);

  return new Map(listMapper);
}
